import React, { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'

interface SiteLinkProps {
    to: string
    className?: string
}

const SiteLink: React.FC<PropsWithChildren<SiteLinkProps>> = ({ to, className = '', children }) => {
    return (
        <Link to={to} className={className} onClick={() => window.scrollTo(0, 0)}>
            {children}
        </Link>
    )
}

export default SiteLink
